<!-- Modal Facturas -->
@if (showFacturasModal) {
<app-modal-facturas
  [clientInfoAndInvoices]="facturasData"
  [isVisible]="showFacturasModal"
  [facturas]="facturasMapeadas"
  [clientName]="clientName"
  (cerrar)="showFacturasModal = false"
  (agregar)="onFacturasAgregadas($event)"
>
</app-modal-facturas>
} @if (showAcuerdosModal) {
<app-modal-acuerdos
  [isVisible]="showAcuerdosModal"
  [acuerdos]="acuerdosData"
  [clientName]="clientName"
  (cerrar)="showAcuerdosModal = false"
  (agregar)="onAcuerdosAgregados($event)"
>
</app-modal-acuerdos>
}

<app-notification
  [show]="showNotification"
  [type]="notificationType"
  [title]="notificationTitle"
  [message]="notificationMessage"
></app-notification>

<!-- Modal de eliminación -->
@if (showConfirmModal) {
<div class="modal-overlay-confirm">
  <div class="modal-content-confirm">
    <h4>Confirmar eliminación</h4>
    <p>¿Estás seguro que deseas eliminar este registro?</p>
    @if (itemToDelete?.tipo === 'factura') {
    <div class="detalles-eliminacion">
      <p><strong>Póliza:</strong> {{ itemToDelete?.data.poliza }}</p>
      <p>
        <strong>Monto:</strong>
        {{ itemToDelete?.data.montoAPagar | currency : "DOP " }}
      </p>
    </div>
    } @else {
    <div class="detalles-eliminacion">
      <p>
        <strong>No. Factura:</strong> {{ itemToDelete?.data.invoiceNumber }}
      </p>
      <p>
        <strong>Monto:</strong>
        {{ itemToDelete?.data.montoAPagar | currency : "DOP " }}
      </p>
    </div>
    }
    <div class="modal-actions">
      <button class="btn-pagar" (click)="confirmarEliminacion()">
        Aceptar
      </button>
      <button class="btn-acuerdos" (click)="cancelarEliminacion()">
        Cancelar
      </button>
    </div>
  </div>
</div>
}

<!-- Contenedor de la página -->
<div class="page-cont col-12">
  <!-- Header -->
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="search-container">
      <label for="filterText">Filtro de clientes</label>
      <input
        type="text"
        class="input-field"
        [(ngModel)]="filterText"
        (ngModelChange)="onFilterTextChange()"
      />
    </div>
    <hr />
  </div>
</div>

<!-- Tabla de clientes -->
<div class="general-table">
  <table>
    <thead>
      <tr>
        @if (!isSmallScreen) {
        <th (click)="ordenar('clientCode')">
          Código
          <i
            class="bi"
            [ngClass]="{
              'bi-arrow-up': sortColumn === 'clientCode' && !sortDesc,
              'bi-arrow-down': sortColumn === 'clientCode' && sortDesc
            }"
          ></i>
        </th>
        <th (click)="ordenar('clientName')">
          Nombre
          <i
            class="bi"
            [ngClass]="{
              'bi-arrow-up': sortColumn === 'clientName' && !sortDesc,
              'bi-arrow-down': sortColumn === 'clientName' && sortDesc
            }"
          ></i>
        </th>
        <th (click)="ordenar('rdBalance')">
          Balance DOP
          <i
            class="bi"
            [ngClass]="{
              'bi-arrow-up': sortColumn === 'rdBalance' && !sortDesc,
              'bi-arrow-down': sortColumn === 'rdBalance' && sortDesc
            }"
          ></i>
        </th>
        <th (click)="ordenar('usBalance')">
          Balance USD
          <i
            class="bi"
            [ngClass]="{
              'bi-arrow-up': sortColumn === 'usBalance' && !sortDesc,
              'bi-arrow-down': sortColumn === 'usBalance' && sortDesc
            }"
          ></i>
        </th>
        <th (click)="ordenar('agreementBalance')">
          Balance de Acuerdo
          <i
            class="bi"
            [ngClass]="{
              'bi-arrow-up': sortColumn === 'agreementBalance' && !sortDesc,
              'bi-arrow-down': sortColumn === 'agreementBalance' && sortDesc
            }"
          ></i>
        </th>
        <th>Facturas</th>
        <th>Acuerdos</th>
        } @else {
        <ng-container *ngFor="let column of visibleColumns">
          <th (click)="ordenar(column.key)">
            {{ column.label }}
            <i
              class="bi"
              [ngClass]="{
                'bi-arrow-up': sortColumn === column.key && !sortDesc,
                'bi-arrow-down': sortColumn === column.key && sortDesc
              }"
            ></i>
          </th>
        </ng-container>
        <th>
          <button class="flecha-btn" (click)="toggleColumnMenu()">
            <img class="flecha-img" src="./assets/flecha.svg" alt="desplegar" />
          </button>
          @if (showColumnMenu) {
          <div class="column-menu">
            <ul>
              <li
                *ngFor="let column of hiddenColumns"
                (click)="switchColumn(column)"
              >
                {{ column.label }}
              </li>
            </ul>
          </div>
          }
        </th>
        }
      </tr>
    </thead>
    <tbody>
      @if (!isSmallScreen) { @for (client of paginatedData; track
      client.clientCode) {
      <tr>
        <td>{{ client.clientCode }}</td>
        <td>{{ client.clientName }}</td>
        <td>{{ client.rdBalance | currency : "$" }}</td>
        <td>{{ client.usBalance | currency : "$" }}</td>
        <td>{{ client.agreementBalance | currency : "$" }}</td>
        <td>
          <button class="btn-acuerdos" (click)="showFacturas(client)">
            Facturas
          </button>
        </td>
        <td>
          <button
            class="btn-acuerdos"
            [disabled]="client.agreementBalance <= 0"
            (click)="showAcuerdos(client)"
          >
            Acuerdos
          </button>
        </td>
      </tr>
      } } @else {
      <ng-container *ngFor="let client of paginatedData; trackBy: trackByFn">
        <tr>
          <ng-container *ngFor="let column of visibleColumns">
            <td>
              @if(column.key === 'actions') {
              <button class="btn-acuerdos" (click)="showFacturas(client)">
                Facturas
              </button>
              <button
                class="btn-acuerdos"
                [disabled]="client.agreementBalance <= 0"
                (click)="showAcuerdos(client)"
              >
                Acuerdos
              </button>
              } @else {
              {{ formatValue(client[column.key], column) }}
              }
            </td>
          </ng-container>
        </tr>
      </ng-container>
      }
    </tbody>
  </table>
</div>

<!-- Contenedor de la paginación -->
<div class="pagination-container">
  <button
    class="page-link"
    [disabled]="currentPage === 1"
    (click)="onPageChange(currentPage - 1)"
  >
    anterior
  </button>

  <ul class="pagination">
    <li class="page-item" [class.active]="currentPage === 1">
      <a class="page-link" (click)="onPageChange(1)">1</a>
    </li>

    @if (currentPage > 3 && totalPages > 5) {
    <li class="page-item">
      <span class="page-link">...</span>
    </li>
    } @for (page of getVisiblePages(); track page) {
    <li class="page-item" [class.active]="currentPage === page">
      <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
    </li>
    } @if (currentPage < totalPages - 2 && totalPages > 5) {
    <li class="page-item">
      <span class="page-link">...</span>
    </li>
    } @if (totalPages > 1) {
    <li class="page-item" [class.active]="currentPage === totalPages">
      <a class="page-link" (click)="onPageChange(totalPages)">{{
        totalPages
      }}</a>
    </li>
    }
  </ul>

  <button
    class="page-link"
    [disabled]="currentPage === totalPages"
    (click)="onPageChange(currentPage + 1)"
  >
    siguiente
  </button>
</div>

<!-- Componente de Items Seleccionados -->
<div class="facturas-seleccionadas">
  <h4>Facturas seleccionadas</h4>

  <table>
    <thead>
      <tr>
        @if (!isSmallScreen) {
        <th>Póliza</th>
        <th>Factura</th>
        <th>Balance</th>
        <th>Monto a Pagar</th>
        <th>Tipo</th>
        <th>Acción</th>
        } @else {
        <ng-container *ngFor="let column of visibleFacturasColumns">
          <th>{{ column.label }}</th>
        </ng-container>
        <th>
          <button class="flecha-btn" (click)="toggleFacturasColumnMenu()">
            <img class="flecha-img" src="./assets/flecha.svg" alt="desplegar" />
          </button>
          @if (showFacturasColumnMenu) {
          <div class="column-menu">
            <ul>
              <li
                *ngFor="let column of hiddenFacturasColumns"
                (click)="switchFacturasColumn(column)"
              >
                {{ column.label }}
              </li>
            </ul>
          </div>
          }
        </th>
        }
      </tr>
    </thead>
    <tbody>
      @if (!isSmallScreen) { @for (factura of facturasSeleccionadas; track
      factura.factura) {
      <tr>
        <td>{{ formatearPoliza(factura.poliza) }}</td>
        <td>{{ factura.factura }}</td>
        <td>{{ factura.balance | currency : "DOP " }}</td>
        <td>{{ factura.montoAPagar | currency : "DOP " }}</td>
        <td>Factura</td>
        <td>
          <button class="btn-eliminar" (click)="eliminarFactura(factura)">
            <i class="bi bi-trash"></i>
          </button>
        </td>
      </tr>
      } } @else {
      <ng-container
        *ngFor="let factura of facturasSeleccionadas; trackBy: trackByFn"
      >
        <tr>
          <ng-container *ngFor="let column of visibleFacturasColumns">
            <td>
              @if(column.key === 'actions') {
              <button class="btn-eliminar" (click)="eliminarFactura(factura)">
                <i class="bi bi-trash"></i>
              </button>
              } @else {
              {{ formatValue(factura[column.key], column) }}
              }
            </td>
          </ng-container>
        </tr>
      </ng-container>
      }
    </tbody>
  </table>

  <h4 class="mt-4">Acuerdos seleccionados</h4>
  <table>
    <thead>
      <tr>
        <th>No. Acuerdo</th>
        <th>Facturas</th>
        <th>Total a Pagar</th>
        <th>Tipo</th>
        <th>Acción</th>
      </tr>
    </thead>
    <tbody>
      @for (grupo of acuerdosAgrupados; track grupo.idAgreement) {
      <tr>
        <td>{{ grupo.idAgreement }}</td>
        <td>
          <ul class="facturas-list">
            @for (factura of grupo.facturas; track factura.invoiceNumber) {
            <li>
              {{ factura.invoiceNumber }} -
              {{ factura.paymentValue | currency : "DOP " }}
            </li>
            }
          </ul>
        </td>
        <td>{{ grupo.totalPagar | currency : "DOP " }}</td>
        <td>Acuerdo</td>
        <td>
          <button class="btn-eliminar" (click)="eliminarAcuerdo(grupo)">
            <i class="bi bi-trash"></i>
          </button>
        </td>
      </tr>
      }
    </tbody>
  </table>
  @if (facturasSeleccionadas.length > 0 || acuerdosAgrupados.length > 0) {
  <div class="total-pagar">
    <span>Total a pagar:</span>
    <span>{{ totalAPagar | currency : "DOP " }}</span>
    <div class="buttons-container">
      <button class="btn-acuerdos" (click)="limpiarSeleccion()">Limpiar</button>
      <button class="btn-pagar" (click)="abrirModalPago()">Pagar</button>
    </div>
  </div>
  }
</div>

<!-- Modal de Pago -->
@if (showModalPago) {
<div class="modal-overlay">
  <div class="modal-content">
    <h4 class="pago-h4">Información de Pago</h4>

    <form (ngSubmit)="procesarPago()" #pagoForm="ngForm">
      <div class="card-form">
        <div class="card-chip"></div>
        <img src="assets/logo-w.svg" alt="Mastercard" class="card-brand" />

        <div class="card-number">
          <input
            type="text"
            id="cardNumber"
            name="cardNumber"
            [(ngModel)]="datosPago.CardNumber"
            required
            (input)="formatearNumeroTarjeta($event)"
            (paste)="onPaste($event)"
            (keyup)="formatearNumeroTarjeta($event)"
            maxlength="19"
            class="card-input"
            placeholder="0000-0000-0000-0000"
          />
        </div>

        <div class="card-footer">
          <div class="card-details">
            <div>
              <label class="card-label">Fecha de Expiración</label>
              <input
                type="text"
                id="expiration"
                name="expiration"
                [(ngModel)]="datosPago.Expiration"
                required
                (keypress)="validarFecha($event)"
                pattern="(0[1-9]|1[0-2])\/([0-9]{2})"
                class="card-input"
                placeholder="MM/YY"
              />
            </div>

            <div>
              <label class="card-label">CVV</label>
              <input
                type="text"
                id="cvv"
                name="cvv"
                [(ngModel)]="datosPago.CardCvv"
                required
                maxlength="5"
                pattern="[0-9]{3,5}"
                (keypress)="validarCVV($event)"
                class="card-input"
                placeholder="000"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="modal-buttons">
        <button type="button" class="btn-acuerdos" (click)="cerrarModalPago()">
          Cancelar
        </button>
        <button
          type="submit"
          class="btn-pagar"
          [disabled]="!validarFormularioPago()"
        >
          Procesar Pago
        </button>
      </div>
    </form>
  </div>
</div>
}

<!-- Modal de Confirmación de Pago -->
@if (showConfirmacionPago) {
<div class="modal-overlay">
  <div class="modal-content-payment">
    @if (isProcessingPayment) {
    <div class="payment-loader">
      <div class="spinner"></div>
      <p>Procesando pago...</p>
    </div>
    } @else {
    <h4 class="pago-h4">Confirmar Pago</h4>

    <div class="resumen-pago">
      <div class="tarjeta-info">
        <span class="info-label">Tarjeta:</span>
        <span class="info-value"
          >**** **** **** {{ datosPago.CardNumber.slice(-4) }}</span
        >
        <span class="info-label">Vence:</span>
        <span class="info-value">{{ datosPago.Expiration }}</span>
      </div>

      <div class="documentos-lista">
        @for (detalle of datosPago.Details; track detalle.DocumentNumber + '_' +
        detalle.DocumentType + '_' + detalle.PaymentValue) {
        <div class="documento-item">
          <div class="documento-info">
            <span class="documento-tipo">
              {{ detalle.tipo }}
            </span>
            <span class="documento-numero">#{{ detalle.DocumentNumber }}</span>
          </div>
          <span class="documento-monto">{{
            detalle.PaymentValue | currency : "DOP "
          }}</span>
        </div>
        }
      </div>

      <div class="total-resumen">
        <span>Total a Pagar:</span>
        <span class="monto-total">{{
          calcularTotalPago() | currency : "DOP "
        }}</span>
      </div>
    </div>

    <div class="modal-actions">
      <button class="btn-acuerdos" (click)="cancelarConfirmacion()">
        Cancelar
      </button>
      <button
        [disabled]="isProcessingPayment"
        class="btn-pagar"
        (click)="confirmarPago()"
      >
        Confirmar Pago
      </button>
    </div>
    }
  </div>
</div>
}
